import BN from "bn.js";

const Math = {

  getAverageNumber: function(total, count){
    if (Number(count) === 0) return 0;
    return (total / count).toFixed(1);
  },

  formatDecimals: function(amount, decimals){
    if (!amount || !decimals || amount === "?" || decimals === "?") {
      return "?";
    }
    const amountBN = new BN(amount);
    const decimalsBN = new BN(decimals);
    const divisor = new BN(10).pow(decimalsBN);
    const beforeDecimal = amountBN.div(divisor);
    const afterDecimal = amountBN.mod(divisor);
    return beforeDecimal + (afterDecimal > 0 ? "." + afterDecimal.toString().substring(0, 4) : '');
  },

  addDecimals: function(amount, decimals){
    const amountBN = new BN(amount);
    const decimalsBN = new BN(decimals);
    const multiplier = new BN(10).pow(decimalsBN);
    return amountBN.mul(multiplier);
  },

  removeDecimals: function(amount, decimals){
    const amountBN = new BN(amount);
    const decimalsBN = new BN(decimals);
    const divider = new BN(10).pow(decimalsBN);
    return amountBN.div(divider);
  }
};

export default Math;